const l = (t) => new Promise((e, i) => {
  const h = new Image(), n = (window.URL || window.webkitURL).createObjectURL(t);
  h.onload = () => {
    (window.URL || window.webkitURL).revokeObjectURL(n), e({
      dimensions: {
        height: h.naturalHeight,
        width: h.naturalWidth
      },
      image: h,
      size: t.size
    });
  }, h.onerror = () => {
    i(new Error("Failed to load image"));
  }, h.src = n;
}), u = (t) => new Promise((e, i) => {
  const h = new Image();
  h.onload = () => {
    e({
      dimensions: {
        height: h.naturalHeight,
        width: h.naturalWidth
      },
      image: h
    });
  }, h.onerror = () => {
    i(new Error("Failed to load image"));
  }, h.src = `data:image;base64,${t}`;
}), f = (t, e) => {
  if (e === 1) {
    const n = t.height > t.width ? t.height : t.width;
    return {
      height: n,
      width: n
    };
  }
  if (!e)
    return {
      height: t.height,
      width: t.width
    };
  let i = t.height, h = t.width;
  if (e > 1) {
    i = t.width * (1 / e);
    const n = t.height - i;
    n > 0 && (i += n, h += n * e);
  } else {
    h = t.height * e;
    const n = t.width - h;
    n > 0 && (h += n, i += n * (1 / e));
  }
  return {
    height: i,
    width: h
  };
}, c = (t) => t * Math.PI / 180, g = (t, e, i) => {
  const h = c(i);
  return {
    height: Math.abs(Math.sin(h) * t) + Math.abs(Math.cos(h) * e),
    width: Math.abs(Math.cos(h) * t) + Math.abs(Math.sin(h) * e)
  };
}, b = (t, e, i = 0, h = {
  horizontal: !1,
  vertical: !1
}) => {
  const n = document.createElement("canvas"), r = n.getContext("2d");
  if (!r)
    return null;
  const d = c(i), {
    width: a,
    height: s
  } = g(t.width, t.height, i);
  n.width = a, n.height = s, r.translate(a / 2, s / 2), r.rotate(d), r.scale(h.horizontal ? -1 : 1, h.vertical ? -1 : 1), r.translate(-t.width / 2, -t.height / 2), r.drawImage(t, 0, 0);
  const o = document.createElement("canvas"), w = o.getContext("2d");
  return w ? (o.width = e.width, o.height = e.height, w.drawImage(n, e.x, e.y, e.width, e.height, 0, 0, e.width, e.height), {
    base64Data: o.toDataURL("image/png").split(",")[1],
    height: e.height,
    width: e.width
  }) : null;
}, m = ({
  dimensions: t,
  minDimensions: e,
  maxSizeInMbs: i,
  size: h
}) => {
  if (!(!t && !h)) {
    if (t && e) {
      const {
        height: n,
        width: r
      } = t, {
        height: d,
        width: a
      } = e;
      if (n < d || r < a)
        throw new Error(`File should be at least ${a || 0}x${d || 0}, current image size is ${r}x${n}`);
    }
    if (h && i && h > i * 1024 * 1024)
      throw new Error(`File should be less than ${i} MBs`);
  }
};
export {
  b as getCroppedImg,
  f as getImageDimensions,
  u as getImageFromBase64Data,
  l as getImageFromFile,
  c as getRadianAngle,
  g as rotateSize,
  m as validateImage
};
//# sourceMappingURL=utils.js.map
